export default {
  namespaced: true,
  state: {
    id: null,
    status: '',
  },
  mutations: {
    UPDATE_KOMADS_ID(state, val) {
      state.id = val
    },
    UPDATE_KOMADS_STATUS(state, val) {
      state.status = val
    },
  },
  actions: {},
}
